import { useTranslation } from 'react-i18next';
import { Button, Drawer } from '@/components';
import { Project } from '@/features/projects/types';
import { FinancialHighlightsForm, FinancialHighlightsSubmitFields } from './financial-highlights-form-new';

export type FinancialHighlightsDrawerProps = {
  readonly formId: string;
  readonly project: Project;
  readonly isOpen: boolean;
  readonly onSubmit: (item: any, description?: string) => void;
  readonly onClose: () => void;
};

export function FinancialHighlightsDrawer({ formId, project, isOpen, onSubmit, onClose }: FinancialHighlightsDrawerProps) {
  const { t } = useTranslation(['projects']);
  const footer = (
    <>
      <Button size="lg" color="neutral" onClick={onClose}>
        {t('Cancel')}
      </Button>
      <Button type="submit" form={formId} size="lg" color="primary">
        {t('Save')}
      </Button>
    </>
  );

  return (
    <Drawer title={t('Financial Highlights')} open={isOpen} onClose={onClose} footer={footer}>
      <FinancialHighlightsForm
        id={formId}
        project={project}
        onSubmit={(data: FinancialHighlightsSubmitFields) => onSubmit({financial_highlights: [data]}, t('Financial Highlights has been updated'))}
      />
    </Drawer>
  );
}
